var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
export var TooltipBody = function (_a) {
    var text = _a.text, children = _a.children, renderTooltip = _a.renderTooltip, className = _a.className, position = _a.position;
    var shouldRender = (text && text.trim()) || children || renderTooltip;
    if (!shouldRender) {
        return null;
    }
    return renderTooltip ? (_jsx("div", { className: "c-info-tooltip-new__custom-content", children: renderTooltip() })) : (_jsx("div", { className: classnames('c-info-tooltip-new__content', {
            'c-info-tooltip-new__content-left': position === 'left',
            'c-info-tooltip-new__content-bottom': position === 'bottom',
        }, className), children: text || children }));
};
export var TooltipTrigger = function (_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return (_jsx("div", __assign({ className: "c-info-tooltip-new-handler ".concat(className) }, props, { children: children })));
};
